import { Alert } from 'antd';
import { useTranslation } from 'translations/hooks';

type InProgressReportProps = {
  operatorValidation?: boolean;
};

export const InProgressReport = ({
  operatorValidation,
}: InProgressReportProps) => {
  const { t } = useTranslation();

  if (operatorValidation) {
    return null;
  }

  return (
    <Alert
      className="alert"
      message={t('pages.print.inProgressReport')}
      banner
      type="warning"
    />
  );
};
